<form>
    <div *ngIf="data" class="message">
        <span>{{data}}</span>
    </div>
    <div class="modal-footer btn-box">
        <button type="button" class="btn btn-light btn-back" (click)="activeModal.dismiss(false)">{{ 'NO' | translate}}</button>
        <button type="button" class="btn btn-primary btn-create" (click)="onConfirm()">{{ 'YES'| translate}}</button>
    </div>
</form>